import { ArrowLeft, ArrowRight } from 'lucide-react'
import { useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useApp } from '../app-context'
import { Logo } from '../components/Logo'
import { SiteFooter } from '../components/SiteFooter'
import { policies, policyBySlug, policyUpdated, type PolicySlug } from '../policies'

export function Policy({ slug }: { slug: PolicySlug }) {
  const { actor } = useApp()
  const policy = policyBySlug(slug)
  useEffect(() => { window.scrollTo(0, 0) }, [slug])
  if (!policy) return null

  return (
    <div className="policy-page">
      <header className="public-nav">
        <Link to="/"><Logo /></Link>
        <nav className="policy-nav" aria-label="Policies">
          {policies.map(({ slug: href, navLabel }) => (
            <NavLink key={href} to={`/${href}`} className={({ isActive }) => isActive ? 'active' : ''}>{navLabel}</NavLink>
          ))}
        </nav>
        <div className="public-nav__actions">
          {actor ? (
            <Link className="button button--dark" to="/dashboard">Dashboard <ArrowRight size={16} /></Link>
          ) : (
            <Link className="text-link" to="/login">Sign in</Link>
          )}
        </div>
      </header>

      <main className="policy">
        <Link to="/" className="back-link"><ArrowLeft size={16} />Back</Link>
        <div className="eyebrow"><span aria-hidden="true" />Legal</div>
        <h1>{policy.title}</h1>
        <p className="policy__summary">{policy.summary}</p>
        <p className="policy__updated">Last updated {policyUpdated}</p>

        {policy.sections.map((section, index) => (
          <section key={section.heading}>
            <h2><i aria-hidden="true">{String(index + 1).padStart(2, '0')}</i>{section.heading}</h2>
            {section.blocks.map((block, blockIndex) =>
              typeof block === 'string'
                ? <p key={blockIndex}>{block}</p>
                : <ul key={blockIndex}>{block.list.map(item => <li key={item}>{item}</li>)}</ul>
            )}
          </section>
        ))}

        <nav className="policy__siblings" aria-label="Other policies">
          {policies.filter(other => other.slug !== slug).map(other => (
            <Link key={other.slug} to={`/${other.slug}`}>{other.title} <ArrowRight size={15} /></Link>
          ))}
        </nav>
      </main>

      <SiteFooter />
    </div>
  )
}
